import { css } from 'emotion';
import { Direction, As, Position } from './';
import { animationTransition } from '@joykit/variables';
import { animations } from './animations';

export namespace styles {
  export const wrapper = css({
    width: '100%'
  });

  export const container = (asProp: As, from: Direction, position?: Position) => {
    const animationStates = animations.getAnimationStates(from);

    return css(
      {
        display: 'flex',
        flexGrow: 1,
        position: 'relative',
        transition: animationTransition('opacity', 'transform'),
        opacity: 0,
        transform: `translateX(${from === 'left' ? '-' : ''}5rem)`
      },
      {
        '&.slide-enter-active': {
          ...animationStates.entering
        },
        '&.slide-enter-done': {
          ...animationStates.entered,
          position: 'relative'
        },
        '&.slide-exit-active': {
          ...animationStates.exiting
        }
      },
      position && position === 'absolute'
        ? {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
          }
        : undefined
    );
  };
}
